@if (dataForm()) {
  <div class="wrapper">
    <form [formGroup]="dataForm()" autocomplete="on">
      <p class="info">
        {{ 'SIGN.PPUIR' | translate }}
      </p>
      <app-email-input />
      @if (emailExistError()) {
        <div class="warning">
          <p class="message">{{ 'SIGN.EJCE' | translate }}</p>
        </div>
      }
      <br />
      <app-phone-input />
      @if (phoneExistError()) {
        <div class="warning">
          <p class="message">{{ 'SIGN.ETJC' | translate }}</p>
        </div>
      }
      @if (showWarning$ | async; as errorMassage) {
        <br />
        <div class="warning">
          <p class="message">{{ errorMassage | translate }}</p>
        </div>
      }
      <br />
      <div class="submit-spinner">
        <app-submit-spinner [loading]="loading()" [label]="'SIGN.REG'" [isValid]="valid()" (click)="submit()" />
      </div>
    </form>
  </div>
}
